import { Col, Row } from '@microfrontends/react-components'
import Link from 'next/link'
import { useRouter } from 'next/router'
import { useContext } from 'react'
import Banner from '../../../components/NumerologyV2/Banner'
import { BaseNumber } from '../../../components/NumerologyV2/Number'
import AppContext from '../../../context/AppContext'
import { MyRulingNumberCss } from '../Numerology.css'

interface IProps {
	rulingNumber: number | null
}

export default function MyRulingNumber({ rulingNumber }: IProps) {
	const { t } = useContext(AppContext)
	const router = useRouter()
	return (
		<Row align='middle' justify='center' container={{ md: 12 }}>
			<Col>
				<Link href={`/${router.pathname}/${t('/result')}`} passHref>
					<MyRulingNumberCss>
						<BaseNumber number={rulingNumber ?? 0} dbStar={true} />
						<div className='line' />
						<div className='block'>
							<h3>Xin chào!</h3>
							<p>Đây là con số chủ đạo của bạn. </p>
						</div>
					</MyRulingNumberCss>
				</Link>
			</Col>
		</Row>
	)
}
